import styled, { css } from 'styled-components';

import { mediaDesktop } from 'utils/styles/responsive';

export const JoinUsGallerySectionWrapper = styled.div`
  max-width: 100vw;
  grid-column: 1/-1;
  margin: 64px 0;

  overflow-x: hidden;

  ${mediaDesktop(
    css`
      margin: 136px 0;
    `
  )}
`;

export const Image = styled.img`
  width: 280px;
  margin-right: 32px;
  user-select: none;
  pointer-events: none;

  &:first-child {
    margin-left: 16px;
  }

  &:last-child {
    margin-right: 16px;
  }

  ${mediaDesktop(css`
    width: 480px;
    margin-right: 64px;

    &:first-child {
      margin-left: 92px;
    }

    &:last-child {
      margin-right: 92px;
    }
  `)}
`;

export const ImagesWrapper = styled.div`
  pointer-events: none;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  white-space: nowrap;
`;
